const key = 'iscilikler';

export const saveIscilik = (kulModelKodu, data) => {
  try {
    const iscilikObj = {
      KUL_MODEL_KODU: kulModelKodu,
      DATE: new Date(),
      DATA: data,
    };
    let iscilikler = loadIscilikler();
    iscilikler = [...iscilikler, iscilikObj];
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(iscilikler));
  } catch (error) {

  }
};

// Modele ait iscilikler kontrol eder. Tarih aynı gün değilse siler ve boş döner. Değilse, iscilik datasını döner.
export const loadIscilik = (kulModelKodu) => {
  try {
    const iscilikler = loadIscilikler();
    const filtered = iscilikler.filter((h) => h.KUL_MODEL_KODU === kulModelKodu);
    if (filtered.length === 0) { // localde yok. Return empty.
      return [];
    }
    if (filtered.length > 1) { // aynı modele ait birden fazla iscilik verisi olamaz. Something is wrong!. Clear locale data and return empty.
      removeIscilik(kulModelKodu);
      return [];
    }
    const iscilik = filtered[0];
    const now = new Date();
    const ld = new Date(iscilik.DATE); // Last Date
    if (now.getYear() === ld.getYear() && now.getMonth() === ld.getMonth() && now.getDate() === ld.getDate()) {
      return iscilik.DATA;
    }
    removeIscilik(kulModelKodu);
    return [];
  } catch (error) {
    return [];
  }
};

export const checkIscilik = (kulModelKodu) => {
  try {
    const iscilikler = loadIscilikler();
    const filtered = iscilikler.filter((h) => h.KUL_MODEL_KODU === kulModelKodu);
    return filtered.length !== 0;
  } catch (error) {
    return false;
  }
};

export const removeIscilikAll = () => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (error) {
    return false;
  }
};

// /////////// HELPER METHODS (NOT EXPORTED) /////////////////////

// localstorage'daki tüm iscilikleri getirir.
const loadIscilikler = () => {
  try {
    let isciliklerTxt = localStorage.getItem(key);
    if (isciliklerTxt === null) {
      localStorage.setItem(key, '[]');
      isciliklerTxt = '[]';
    }
    return JSON.parse(isciliklerTxt);
  } catch (error) {
    return [];
  }
};


// Modele ait tüm iscilikler local storage'dan silinir.
const removeIscilik = (kulModelKodu) => {
  try {
    const iscilikler = loadIscilikler();
    const otherIscilikler = iscilikler.filter((h) => h.KUL_MODEL_KODU !== kulModelKodu);
    localStorage.setItem(key, JSON.stringify(otherIscilikler));
    return true;
  } catch (error) {
    return false;
  }
};
